<template>
  <div id="other-author-decline"
       class="flex-center">
    <div class="ipub-block ipub-shadow">
      <div class="ipub-h4 mar-b-20 tips flex">
        <ipub-icon style="font-size:30px"
                   class="key-color"
                   type="iconDetails" />
        <font class="mar-l-12">Decline Contributor Verification</font>
      </div>
      <div class="ipub-p2 mar-b-20">
        Thank you for taking the time to notify <font class="ipub-p1">{{article.journal.fullName}}</font> that you are not a Contributing Author on "<font class="ipub-p1">{{article.title}}</font>" submitted by <font class="ipub-p1">{{article.firstName}} {{article.lastName}}</font>
      </div>
      <ipub-button type="primary"
                   @click="confirm">Confirm</ipub-button>
      <ipub-button type="primary"
                   plain
                   @click="cancel">Cancel</ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
